import useStore from "../hooks/useStore";
import MonthsDialog from "./MonthsDialog";

const MonthAndDatePicker = () => {
  const month = useStore((state) => state.selectedMonth);
  const setMonth = useStore((state) => state.setSelectedMonth);

  const year = useStore((state) => state.selectedYear);
  const setYear = useStore((state) => state.setSelectedYear);

  const canGoToPreviousMonth = useStore((state) => state.canGoToPreviousMonth);

  const goToNextMonth = () => {
    const nextMonth = month.value + 1;

    if (nextMonth > 11) {
      setMonth(0);
      setYear(year.value + 1);
      return;
    }

    setMonth(nextMonth);
  };

  const goToPreviousMonth = () => {
    const previousMonth = month.value - 1;

    if (previousMonth < 0) {
      setMonth(11);
      setYear(year.value - 1);
      return;
    }

    setMonth(previousMonth);
  };

  return (
    <div
      className={`tw-pb-4 md:tw-pb-0 tw-flex tw-items-center tw-justify-self-center`}
    >
      {/* Prev icon */}
      <svg
        {...(canGoToPreviousMonth() && {
          onClick: goToPreviousMonth,
        })}
        className={`tw-w-8 tw-h-8 ${
          canGoToPreviousMonth()
            ? "tw-text-white tw-cursor-pointer"
            : "tw-text-gray-400 tw-cursor-not-allowed"
        }`}
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          clipRule="evenodd"
        />
      </svg>

      <div className="md:tw-px-5 tw-flex tw-items-center tw-justify-center tw-space-x-2 tw-w-56 md:tw-w-64 xl:tw-w-72">
        <MonthsDialog />
      </div>

      {/* Next icon */}
      <svg
        onClick={goToNextMonth}
        className="tw-w-8 tw-h-8 tw-text-white tw-cursor-pointer"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default MonthAndDatePicker;
